import NoticeBox from './NoticeBox';

export * from './NoticeBox';

export default NoticeBox;
